import { put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import { getGallectionStreamId } from '../helpers';
import { getCurrentMediaSource } from '../selectors';

export default function* (): SagaIterator {
  const mediaSource: ReturnType<typeof getCurrentMediaSource> = yield select(
    getCurrentMediaSource
  );

  const streamId = getGallectionStreamId(mediaSource);

  const isFetching: ReturnType<typeof selectors.isFetching> = yield select(
    selectors.isFetching,
    streamId
  );
  if (isFetching) {
    return;
  }

  yield put(withOffset.actions.fetch(streamId));
}
